import { Paper, Link } from "@material-ui/core";
import { styled } from "@material-ui/core/styles";
import { Box, Typography, Avatar, Chip } from "@material-ui/core";

export const ModernPortCircle = styled(Avatar)(({ theme, bgcolor, isUpdating, isHovered }) => ({
	backgroundColor: bgcolor,
	color: "#ffffff",
	width: 37,
	height: 37,
	fontSize: "11px",
	fontWeight: "700",
	marginBottom: theme.spacing(0.5),
	transition: "all 0.2s ease",
	boxShadow: isHovered ? "0 4px 12px rgba(0,0,0,0.2)" : "0 2px 6px rgba(0,0,0,0.15)",
	transform: isHovered ? "scale(1.08)" : "scale(1)",
	border: isHovered ? "3px solid #f8fafc" : "none",
	textShadow: "0 1px 2px rgba(0,0,0,0.3)",

	opacity: isUpdating ? 0.8 : 1,
	animation: isUpdating ? "subtlePulse 1.2s ease-in-out infinite" : "none",
}));

export const CleanPortLabel = styled(Typography)(({ theme }) => ({
	fontSize: "11px",
	fontWeight: "600",
	textAlign: "center",
	color: "#ffffffff",
	lineHeight: "1.2",
}));

export const CleanTooltipPaper = styled(Paper)(({ theme }) => ({
	background: "#ffffff",
	borderRadius: "8px",
	boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
	border: "1px solid #e5e7eb",
	minWidth: "260px",
	maxWidth: "320px",
	overflow: "hidden",
}));

export const TooltipHeader = styled(Box)(({ theme }) => ({
	padding: "14px 16px",
	background: "#4285f4",
	color: "#ffffff",
}));

export const TooltipContent = styled(Box)(({ theme }) => ({
	padding: "14px 16px",
}));

export const PortTitle = styled(Typography)(({ theme }) => ({
	color: "#ffffff",
	fontWeight: "600",
	fontSize: "15px",
	marginBottom: "3px",
}));

export const PortSubtitle = styled(Typography)(({ theme }) => ({
	color: "rgba(255,255,255,0.9)",
	fontSize: "12px",
	textTransform: "uppercase",
	letterSpacing: "0.4px",
	fontWeight: "500",
}));

export const OrderItem = styled(Box)(({ theme }) => ({
	display: "flex",
	alignItems: "center",
	justifyContent: "space-between",
	padding: "10px 0",
	borderBottom: "1px solid #f3f4f6",

	"&:hover": {
		background: "#f9fafb",
		borderRadius: "6px",
		transition: "background-color 0.2s ease",
	},
}));

export const OrderTypeChip = styled(Chip)(({ theme, ordertype }) => ({
	height: "22px",
	fontSize: "10px",
	fontWeight: "600",
	textTransform: "uppercase",
	letterSpacing: "0.3px",
	background: ordertype === "eta" ? "#10B981" : "#e74c3c",
	color: "#ffffff",
	"& .MuiChip-icon": {
		color: "#ffffff",
		fontSize: "13px",
	},
}));

export const OrderLink = styled(Link)(({ theme }) => ({
	color: "#4285f4",
	textDecoration: "none",
	fontSize: "11px",
	fontWeight: "600",
	display: "flex",
	alignItems: "center",
	gap: "4px",
	padding: "4px 8px",
	borderRadius: "4px",
	transition: "all 0.2s ease",
	"&:hover": {
		background: "#f0f9ff",
		textDecoration: "none",
		color: "#1976d2",
	},
}));

export const EmptyState = styled(Box)(({ theme }) => ({
	textAlign: "center",
	padding: "20px 16px",
	color: "#6b7280",
	fontSize: "12px",
	fontStyle: "italic",
}));

export const StatusIndicator = styled(Box)(({ bgcolor }) => ({
	width: "8px",
	height: "8px",
	borderRadius: "50%",
	backgroundColor: bgcolor,
	marginRight: "8px",
}));
